import { getAPIUrl, Post } from "../../../ApiServices/apiMethod";

const addFundEndpoint = {
  checkStatus: "Api/V1/Member/checkPaymentStatus",
  razorAddWallet: "Api/V1/AddFund/AddFundWallet",
  razorVerify: "Api/V1/AddFund/verifyPayment",
  razorReport: "Api/V1/AddFund/addfundReport",
};

export const checkStatus = (data, param = "") => {
  const url = getAPIUrl(addFundEndpoint.checkStatus, param);
  return Post(url, data);
};

export const getRezorAddfund = (data, param = "") => {
  const url = getAPIUrl(addFundEndpoint.razorAddWallet, param);
  return Post(url, data);
};
export const getRezorVerify = (data, param = "") => {
  const url = getAPIUrl(addFundEndpoint.razorVerify, param);
  return Post(url, data);
};
export const getRezorReport = (data, param = "") => {
  const url = getAPIUrl(addFundEndpoint.razorReport, param);
  return Post(url, data);
};
